module.exports = __webpack_public_path__ + "img/object_remove_src_3.ac50654d.webp";